module.exports = __webpack_public_path__ + "static/woyw-4-5743489cdb6989f34401db40be8f6587.png";